// extracted by mini-css-extract-plugin
module.exports =  {"tag":"TagInformation-module__tag___CpJPV"};